import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

// we will connect our reducers here
import { AuthReducer } from "./AuthReducer";
import { OnboardingReducer } from "./OnboardingReducer";
import { CalculatorReducer } from "./CalculatorReducer";

const appReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: AuthReducer,
    onboarding: OnboardingReducer,
    calculator: CalculatorReducer,
  });

const createRootReducer = (history) => (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(history)(state, action);
};

export default createRootReducer;
